import { render, staticRenderFns } from "./CreateCommuneDialog.vue?vue&type=template&id=651f6f3c&scoped=true"
import script from "./CreateCommuneDialog.vue?vue&type=script&lang=js"
export * from "./CreateCommuneDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateCommuneDialog.vue?vue&type=style&index=0&id=651f6f3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651f6f3c",
  null
  
)

export default component.exports